import { render, staticRenderFns } from "./generalmodal.vue?vue&type=template&id=b0431a90&"
import script from "./generalmodal.vue?vue&type=script&lang=js&"
export * from "./generalmodal.vue?vue&type=script&lang=js&"
import style0 from "./generalmodal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports